import info from "../../info.jsonc";
const projects: { title: string; description: string; tags: string[]; link: string; }[] = info.projects;
export function Projects() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 md:px-6">
      <h1 className="text-3xl md:text-4xl font-bold mb-8">Projects</h1>

      <div className="grid md:grid-cols-2 gap-6">
        {projects.map((project, i) => (
          <a
            key={i}
            href={project.link}
            className="block p-6 bg-zinc-900 border border-zinc-800 rounded-xl hover:border-cyan-500/50 transition-colors group"
          >
            <h3 className="text-xl font-semibold mb-2 group-hover:text-cyan-400 transition-colors">
              {project.title}
            </h3>
            <p className="text-zinc-400 mb-4">{project.description}</p>
            <div className="flex flex-wrap gap-2">
              {project.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs px-2 py-1 bg-zinc-800 text-zinc-400 rounded"
                >
                  {tag}
                </span>
              ))}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
